<template>
  <div class="mx-2 mx-md-0">
    <div
      v-if="isMobile"
      class="d-flex justify-content-between align-items-center mb-2 py-2"
    >
      <b-button
        size="sm"
        variant="outline-primary"
        @click="filtersVisible = !filtersVisible"
      >
        <b-icon-funnel-fill class="mr-1" />
        {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
      </b-button>
    </div>

    <div class="d-flex flex-column flex-lg-row" style="gap: 7px; width: 100%;">
      <b-card style="display: inline-block; width: 100%;" :style="{'max-width': isMobile ? 'none' : '300px'}">
        <b-card-text>
          <div
            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;"
          >
            <span>DATES (Optional)</span>
            <div>
              <b-button
                size="sm"
                variant="dark"
                @click="onDateRangeChange"
                style="margin-right: 5px;"
              >
                SEARCH
              </b-button>
              <b-button
                v-if="date_range"
                size="sm"
                variant="outline-danger"
                @click="clearDateFilter"
              >
                CLEAR
              </b-button>
            </div>
          </div>

          <b-input
            id="dates"
            size="sm"
            v-model="date_range"
            placeholder="Select date range (optional)"
            style="width: 100%;"
            :style="{'max-width': isMobile ? 'none' : '250px'}"
            autocomplete="off"
            clearable
          ></b-input>
        </b-card-text>
      </b-card>

      <b-collapse :visible="!isMobile || filtersVisible" style="gap: 7px; width: 100%;">
        <b-card
          style="display: inline-block; width: 100%; vertical-align: top;"
          :style="{'max-width': isMobile ? 'none' : '350px'}"
          v-if="items.length > 0"
        >
          <div>
            <div
              style="display: inline-block; vertical-align: top;"
              v-if="packet.userDetails.userrole == 'admin'"
            >
              <b-button variant="info" size="sm" @click="downloadExcel">
                DOWNLOAD EXCEL
              </b-button>
            </div>
          </div>

          <div style="margin-top: 5px;">
            <b-form-input
              v-model="search_txt"
              size="sm"
              placeholder="SEARCH PRODUCT IN RESULTS"
            ></b-form-input>
          </div>
        </b-card>

        <b-card
          style="display: inline-block; width: 100%; vertical-align: top;"
          :style="{'max-width': isMobile ? 'none' : '240px'}"
          v-if="items.length > 0"
        >
          <div>FILTER CATEGORY</div>
          <div>
            <b-form-select
              :options="categoryOptions"
              v-model="picked_category"
              style="width: 100%;"
              :style="{'max-width': isMobile ? 'none' : '200px'}"
            >
              <template #first>
                <b-form-select-option :value="null">ALL</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </b-card>

        <b-card
          style="display: inline-block; width: 100%; vertical-align: top;"
          :style="{'max-width': isMobile ? 'none' : '240px'}"
          v-if="items.length > 0"
        >
          <div>FILTER ORDER TYPE</div>
          <div>
            <b-form-select
              :options="orderTypeOptions"
              v-model="picked_order_type"
              style="width: 100%;"
              :style="{'max-width': isMobile ? 'none' : '200px'}"
            >
              <template #first>
                <b-form-select-option :value="null">ALL</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </b-card>

        <b-card
          style="display: inline-block; width: 100%; vertical-align: top;"
          :style="{'max-width': isMobile ? 'none' : '240px'}"
          v-if="items.length > 0"
        >
          <div>FILTER SOLD LOCATION</div>
          <div>
            <b-form-select
              :options="soldLocationOptions"
              v-model="picked_sold_location"
              style="width: 100%;"
              :style="{'max-width': isMobile ? 'none' : '200px'}"
            >
              <template #first>
                <b-form-select-option :value="null">ALL</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </b-card>
      </b-collapse>
    </div>

    <b-card style="margin-top: 10px; min-height: 250px; max-height: 100%;">
      <div v-if="items_being_loaded">
        <loading :active="true" :can-cancel="false" :is-full-page="false">
        </loading>
      </div>

      <div v-else>
        <div v-if="items.length == 0">
          <b-alert variant="warning" show
            >NO OUT OF STOCK PRODUCTS FOUND</b-alert
          >
        </div>

        <div v-else style="overflow-x: auto; width: 100%;">
          <table style="border-collapse: collapse; width: 100%;">
            <thead>
              <tr>
                <th
                  class="ipt_tdhr"
                  @click="sortby('invoice_id')"
                  style="min-width: 100px;"
                >
                  INVOICE
                </th>
                <th
                  class="ipt_tdhr"
                  @click="sortby('customer_name')"
                  style="min-width: 100px;"
                >
                  CUSTOMER NAME
                </th>
                <th
                  class="ipt_tdhr"
                  @click="sortby('order_type')"
                  style="min-width: 100px;"
                >
                  ORDER TYPE
                </th>
                <th
                  class="ipt_tdhr"
                  @click="sortby('delivery_date')"
                  style="min-width: 100px;"
                >
                  DELIVERY DATE
                </th>
                <th
                  class="ipt_tdhr"
                  @click="sortby('product_description')"
                  style="min-width: 250px;"
                >
                  PRODUCT NAME
                </th>
                <th
                  class="ipt_tdhr"
                  @click="sortby('product_sku')"
                  style="min-width: 150px;"
                >
                  PRODUCT SKU
                </th>
                <th
                  class="ipt_tdhr"
                  @click="sortby('category')"
                  style="min-width: 100px;"
                >
                  CATEGORY
                </th>

                <th
                  class="ipt_tdhr"
                  @click="sortby('sold_location')"
                  style="min-width: 200px;"
                >
                  SOLD LOCATION
                </th>

                <th class="ipt_tdhr" @click="sortby('quantity')">
                  QTY
                </th>

                <th
                  class="ipt_tdhr"
                  @click="sortby('sale_price')"
                  v-if="packet.userDetails.userrole == 'admin'"
                  style="min-width: 100px;"
                >
                  SALE PRICE
                </th>

                <th
                  class="ipt_tdhr"
                  @click="sortby('wholesale_price')"
                  v-if="packet.userDetails.userrole == 'admin'"
                  style="min-width: 90px;"
                >
                  WHOLESALE PRICE
                </th>

                <th
                  class="ipt_tdhr"
                  @click="sortby('landed_cost')"
                  v-if="packet.userDetails.userrole == 'admin'"
                  style="min-width: 90px;"
                >
                  LANDED COST
                </th>

                <th class="ipt_tdhr" @click="sortby('quantity')">
                  RESERVED
                </th>

                <th
                  class="ipt_tdhr"
                  @click="sortby('locsub')"
                  style="min-width: 250px;"
                >
                  TARGET LOCATION
                </th>

                <th class="ipt_tdhr" style="min-width: 200px;">
                  STATUS
                </th>

                <th class="ipt_tdhr" style="min-width: 150px;">
                  MERCH STATUS
                </th>

                <th class="ipt_tdhr">
                  ACTIONS
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>

                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>

                <td
                  class="ipt_tdhr"
                  style="font-weight: bold; background-color: lightyellow;"
                  v-if="packet.userDetails.userrole == 'admin'"
                >
                  $
                  {{
                    numberWithCommas((total("sale_price") || 0.0).toFixed(2))
                  }}
                </td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: bold; background-color: lightyellow;"
                  v-if="packet.userDetails.userrole == 'admin'"
                >
                  $
                  {{
                    numberWithCommas(
                      (total("wholesale_price") || 0.0).toFixed(2)
                    )
                  }}
                </td>

                <td
                  class="ipt_tdhr"
                  style="font-weight: bold; background-color: lightyellow;"
                  v-if="packet.userDetails.userrole == 'admin'"
                >
                  $
                  {{
                    numberWithCommas((total("landed_cost") || 0.0).toFixed(2))
                  }}
                </td>

                <td
                  class="ipt_tdhr"
                  style="font-weight: bold; background-color: lightyellow;"
                >
                  {{ total("quantity") || 0.0 }}
                </td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: bold; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: bold; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: bold; background-color: lightyellow;"
                ></td>
                <td
                  class="ipt_tdhr"
                  style="font-weight: normal; background-color: lightyellow;"
                ></td>
              </tr>
            </tbody>
            <tbody>
              <tr
                v-for="(item, idx) in items"
                v-bind:key="idx"
                v-if="allowed(item)"
              >
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.invoice_id }}
                </td>
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.customer_name }}
                </td>
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{
                    item.order_type &&
                      item.order_type.toUpperCase().replace("_", " ")
                  }}
                </td>
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.delivery_date }}
                </td>
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.product_description }}
                </td>
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.product_sku }}
                </td>
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.category }}
                </td>
                <td class="ipt_tdr" style="font-weight: normal;">
                  {{
                    (packet.locationsdict[item.location_id] || "").toUpperCase()
                  }}
                  /
                  {{
                    (
                      packet.sublocationsdict[item.sublocation_id] || ""
                    ).toUpperCase()
                  }}
                </td>

                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.quantity || 0 }}
                </td>

                <td
                  class="ipt_tdr"
                  style="font-weight: normal;"
                  v-if="packet.userDetails.userrole == 'admin'"
                >
                  $ {{ (item.sale_price || 0.0).toFixed(2) }}
                </td>
                <td
                  class="ipt_tdr"
                  style="font-weight: normal;"
                  v-if="packet.userDetails.userrole == 'admin'"
                >
                  $ {{ (item.wholesale_price || 0.0).toFixed(2) }}
                </td>
                <td
                  class="ipt_tdr"
                  style="font-weight: normal;"
                  v-if="packet.userDetails.userrole == 'admin'"
                >
                  $ {{ (item.landed_cost || 0.0).toFixed(2) }}
                </td>

                <td class="ipt_tdr" style="font-weight: normal;">
                  {{ item.quantity || 0 }}
                </td>

                <td class="ipt_tdr">
                  <b-form-select
                    size="sm"
                    style="font-size: 10px;"
                    v-model="item.locsub"
                    @change="onLocationChange(item)"
                    @blur="markAsTouched(item)"
                    :disabled="!['admin', 'officeuser'].includes(packet.userDetails.userrole)"
                    :state="shouldShowValidation(item) ? validateLocation(item) : null"
                    required
                  >
                    <b-form-select-option value="" disabled>
                      -- Please select a location --
                    </b-form-select-option>
                    <b-form-select-option
                      v-for="option in getFilteredLocsubs(item)"
                      :key="`${option.location_id}|${option.sublocation_id}`"
                      :value="`${option.location_id}|${option.sublocation_id}`"
                    >
                      {{ all_loc_inventory_dict[concater([item.product_sku, option.location_id, option.sublocation_id])] || 0 }}
                      -
                      {{ (packet.locationsdict[option.location_id] || "").toUpperCase() }}
                      /
                      {{ (packet.sublocationsdict[option.sublocation_id] || "").toUpperCase() }}
                      <span v-if="option.isSoldLocation"> (SOLD LOCATION)</span>
                    </b-form-select-option>
                  </b-form-select>
                  <b-form-invalid-feedback v-if="shouldShowValidation(item)" :state="validateLocation(item)">
                    Target location is required
                  </b-form-invalid-feedback>
                </td>

                <td class="ipt_tdr">
                  <b-form-select
                    :disabled="!['admin', 'officeuser'].includes(packet.userDetails.userrole)"
                    size="sm"
                    style="font-size: 12px;"
                    :options="states"
                    v-model="item.state"
                  >
                  </b-form-select>
                </td>

                <td class="ipt_tdr">
                  <b-form-select
                    :disabled="!['admin', 'officeuser'].includes(packet.userDetails.userrole)"
                    size="sm"
                    style="font-size: 12px;"
                    :options="merch_states"
                    v-model="item.merchandise_status"
                  >
                  </b-form-select>
                </td>

                <td
                  class="ipt_tdr"
                  style="font-weight: normal; padding: 3px;"
                >
                  <b-button
                    :disabled="!['admin', 'officeuser'].includes(packet.userDetails.userrole) || !validateLocation(item)"
                    size="sm"
                    variant="success"
                    @click="add_product_to_inventory(item)"
                  >
                    ADD
                  </b-button>
                  <button
                    @click="move_items(item)"
                    v-if="
                      (item.move_items == false &&
                        packet.userDetails.userrole == 'admin') ||
                        packet.userDetails.userrole == 'accountmanager' ||
                        packet.userDetails.userrole == 'officemanager' ||
                        packet.userDetails.userrole == 'officeuser' ||
                        packet.userDetails.userrole == 'warehousemanager'
                    "
                  >
                    MOVE ITEMS
                  </button>
                  <div
                    v-if="item.move_items"
                    style="text-align: left; width: 350px; margin: auto;"
                  >
                    <div style="margin: 5px; font-size: 12px;">
                      <div>FROM:</div>

                      <b-alert show variant="warning"
                        >{{ packet.locsubsdict[item.locsub] }}
                      </b-alert>
                    </div>
                    <div style="margin: 5px; font-size: 12px;">
                      <div>TO:</div>

                      <b-alert variant="warning" show
                        ><b-form-select
                          size="sm"
                          style="width: 300px; font-size: 12px;"
                          :options="packet.locsubs"
                          v-model="item.to_locsub"
                        ></b-form-select
                      ></b-alert>
                    </div>
                    <div style="margin: 5px; font-size: 12px;">
                      <div>QTY:</div>
                      <b-alert variant="warning" show>
                        <input
                          v-model="item.move_quantity"
                          style="width: 50px; font-weight: bold;"
                        />
                      </b-alert>
                    </div>
                    <button @click="cancel_move(item)">CANCEL MOVE</button>
                    <button @click="submit_move_wrapper(item)">SUBMIT</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Requestor from "@/utilities/Requestor";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import mappings from "@/utilities/mappings";
import "lightpick/css/lightpick.css";
import { BIconFunnelFill } from "bootstrap-vue";

import ItemComments from "@/components/importables/ItemComments";

export default {
  name: "InventoryByLocation",
  components: { flatPickr, Loading, ItemComments, DatePicker: DatePicker },
  data: function() {
    return {
      items: [],
      locations: [],
      location_id: null,
      packet: {},
      items_being_loaded: false,
      item_comments_invoice_id: null,
      item_comments_itemid: null,
      picked_locsub: null,
      all_loc_inventory_dict: {},
      allowed_locsubs: [],
      sort_asc: false,
      hide_zero_in_stock: false,
      search_txt: "",
      picked_category: null,
      picked_order_type: null,
      picked_sold_location: null,
      start_date: null,
      end_date: null,
      date_range: "",
      states: mappings.states,
      merch_states: mappings.merchandise_statuses,
      filtersVisible: false,
      isMobile: false,
      touchedItems: new Set(),
    };
  },
  computed: {
    orderedTotal() {
      return this.items
        .filter(item => this.allowed(item))
        .reduce((sum, item) => sum + Number(item.ordered || 0), 0);
    },
    scheduledTotal() {
      return this.items
        .filter(item => this.allowed(item))
        .reduce((sum, item) => sum + Number(item.scheduled || 0), 0);
    },
    soldsofarTotal() {
      return this.items
        .filter(item => this.allowed(item))
        .reduce((sum, item) => sum + Number(item.sold_so_far || 0), 0);
    },
    categoryOptions() {
      let cats = this.items.map(d => d.category).filter(Boolean);
      return [...new Set(cats)].map(c => ({ value: c, text: c }));
    },
    orderTypeOptions() {
      let cats = this.items.map(d => d.order_type).filter(Boolean);
      return [...new Set(cats)].map(c => ({
        value: c,
        text: c ? c.toUpperCase().replace("_", " ") : ""
      }));
    },
    soldLocationOptions() {
      let cats = this.items
        .map(d => {
          const location = (
            this.packet.locationsdict[d.location_id] || ""
          ).toUpperCase();
          const sublocation = (
            this.packet.sublocationsdict[d.sublocation_id] || ""
          ).toUpperCase();
          return location && sublocation
            ? `${location} / ${sublocation}`
            : location || sublocation;
        })
        .filter(Boolean);

      return [...new Set(cats)].map(c => ({
        value: c,
        text: c
      }));
    }
  },
  methods: {
    validateLocation: function(item) {
      return !!item.locsub && 
            item.locsub.trim() !== '' && 
            item.locsub !== "46|122" && 
            item.locsub !== item.original_locsub; 
    },

    markAsTouched: function(item) {
      this.touchedItems.add(item.itemid);
    },

    shouldShowValidation: function(item) {
      return this.touchedItems.has(item.itemid);
    },

    onLocationChange(item) {
      this.markAsTouched(item);
      if (item.locsub !== item.original_locsub && !["46|122"].includes(item.locsub)) {
        item.merchandise_status = 1;
      }
    },

    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
   
    getFilteredLocsubs: function(item) {
      if (!this.packet.locsubs || this.packet.locsubs.length === 0) {
        return [];
      }

      const TARGET_LOCATION_IDS = [40, 41, 42];
      
      let allOptions = [];

      if (item.location_id && item.sublocation_id) {
        const soldLocation = {
          location_id: item.location_id,
          sublocation_id: item.sublocation_id,
          isSoldLocation: true
        };
        allOptions.push(soldLocation);
      }

      TARGET_LOCATION_IDS.forEach(locationId => {
        const customerVendorOrder = this.packet.locsubs.find(locsub => 
          locsub.location_id === locationId &&
          locsub.sublocation && 
          locsub.sublocation.toUpperCase().includes('CUSTOMER VENDOR ORDERS')
        );
        
        if (customerVendorOrder) {
          allOptions.push(customerVendorOrder);
        }
      });

      const seen = new Set();
      const uniqueOptions = allOptions.filter(locsub => {
        const key = `${locsub.location_id}|${locsub.sublocation_id}`;
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });

      return uniqueOptions.sort((a, b) => {
        if (a.isSoldLocation) return -1;
        if (b.isSoldLocation) return 1;
        
        const aIndex = TARGET_LOCATION_IDS.indexOf(a.location_id);
        const bIndex = TARGET_LOCATION_IDS.indexOf(b.location_id);
        
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }
        
        const locationA = this.packet.locationsdict[a.location_id] || '';
        const locationB = this.packet.locationsdict[b.location_id] || '';
        return locationA.localeCompare(locationB);
      });
    },

    add_product_to_inventory: function(item) {
      this.markAsTouched(item);

      if (!this.validateLocation(item)) {
        this.$bvToast.toast("Please select a target location before adding to inventory.", {
          title: "Missing Location",
          autoHideDelay: 2000,
          variant: "warning"
        });
        return;
      }

      let data = { ...item };

      let [location_id, sublocation_id] = data.locsub.split("|").map(Number);
      data.location_id = location_id;
      data.sublocation_id = sublocation_id;
      data.itemid = item.itemid;
      data.username = this.packet.userDetails.username;

      let that = this;
      let path = "/api/inventory/add_inventory_and_reallocate_single_item/";

      let s = function(response) {
        const resp = response.data;

        if (resp.error) {
          that.$bvToast.toast("ERROR ADDING ITEM TO INVENTORY.", {
            title: "Error",
            autoHideDelay: 1500,
            variant: "warning"
          });
        } else if (resp.result && resp.result.added_quantity > 0) {
          that.$vex.dialog.alert({
            message: resp.result.message,
            callback: () => {
              that.get_out_of_stock_items();
            }
          });

          that.items_to_add = that.items_to_add
            ? that.items_to_add.filter(d => d.idx != item.idx)
            : [];
        } else {
          that.$bvToast.toast("Unexpected response received from server.", {
            title: "Warning",
            autoHideDelay: 2000,
            variant: "warning"
          });
        }

        item.loading = false;
      };

      let f = function(error) {
        that.$bvToast.toast(
          "AN ERROR OCCURRED ADDING ITEM TO INVENTORY. PLEASE TRY AGAIN LATER.",
          { title: "Error", autoHideDelay: 1500, variant: "danger" }
        );
        item.loading = false;
      };

      item.loading = true;
      Requestor.postAsync(path, data, s, f);
    },

    clearDateFilter: function() {
      this.date_range = "";
      this.start_date = null;
      this.end_date = null;
      this.get_out_of_stock_items();
    },

    onDateRangeChange() {
      if (this.date_range && this.date_range.includes("-")) {
        const [start, end] = this.date_range
          .split(" - ")
          .map(d => moment(d, "DD/MM/YYYY").format("YYYY-MM-DD"));
        this.start_date = start;
        this.end_date = end;
      } else {
        this.start_date = null;
        this.end_date = null;
      }
      
      this.get_out_of_stock_items();
    },

    allowed: function(row) {
      let status = true;
      let that = this;
      
      function picked_locsub_fn(row) {
        let status = true;
        if (that.picked_locsub != null) {
          if (row.locsub != that.picked_locsub) {
            status = false;
          } else {
            status = true;
          }
        }
        return status;
      }
      
      function picked_category_fn(row) {
        let status = true;
        if (that.picked_category != null) {
          if (row.category != that.picked_category) {
            status = false;
          }
        }
        return status;
      }
      
      function picked_order_type_fn(row) {
        let status = true;
        if (that.picked_order_type != null) {
          if (row.order_type != that.picked_order_type) {
            status = false;
          }
        }
        return status;
      }
      
      function picked_sold_location_fn(row) {
        let status = true;
        if (that.picked_sold_location != null) {
          const location = (
            that.packet.locationsdict[row.location_id] || ""
          ).toUpperCase();
          const sublocation = (
            that.packet.sublocationsdict[row.sublocation_id] || ""
          ).toUpperCase();
          const locSub =
            location && sublocation
              ? `${location} / ${sublocation}`
              : location || sublocation;

          if (locSub !== that.picked_sold_location) {
            status = false;
          }
        }
        return status;
      }

      function hide_zero_in_stock_fn(row) {
        let status = true;
        if (that.hide_zero_in_stock) {
          if (row.in_stock == 0) {
            status = false;
          }
        }
        return status;
      }

      function search_txt_fn(row) {
        let status = true;
        let product_invoice = row.invoice_id;
        let product_sku = row.product_sku;
        let product_description = row.product_description;
        status =
          product_description
            .toLowerCase()
            .indexOf(that.search_txt.toLowerCase()) > -1 ||
          product_sku.toLowerCase().indexOf(that.search_txt.toLowerCase()) >
            -1 ||
          product_invoice.toLowerCase().indexOf(that.search_txt.toLowerCase()) >
            -1;
        return status;
      }

      if (
        picked_locsub_fn(row) == false ||
        picked_category_fn(row) == false ||
        picked_order_type_fn(row) == false ||
        picked_sold_location_fn(row) == false ||
        hide_zero_in_stock_fn(row) == false ||
        search_txt_fn(row) == false
      ) {
        status = false;
      }

      return status;
    },

    downloadExcel: function() {
      let filtered = this.items.filter(row => this.allowed(row));

      if (filtered.length === 0) {
        alert("No data to export!");
        return;
      }

      let ws_data = filtered.map(item => ({
        Product: item.product_description,
        SKU: item.product_sku,
        Category: item.category,
        Sublocation: this.packet.locsubsdict[item.locsub],
        Ordered: item.ordered || 0,
        Scheduled: item.scheduled || 0,
        InStock: item.in_stock,
        Reserved: item.quantity,
        Available: item.available,
        SellingPrice: item.sale_price,
        WholesalePrice: item.wholesale_price,
        LandedCost: item.landed_cost
      }));

      function escapeCSV(value) {
        if (value === null || value === undefined) return "";
        value = value.toString();
        if (/[",\n]/.test(value)) {
          value = '"' + value.replace(/"/g, '""') + '"';
        }
        return value;
      }

      let headers = Object.keys(ws_data[0])
        .map(escapeCSV)
        .join(",");
      let rows = ws_data
        .map(obj =>
          Object.values(obj)
            .map(escapeCSV)
            .join(",")
        )
        .join("\n");

      let csvContent = "data:text/csv;charset=utf-8," + headers + "\n" + rows;

      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "inventory_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    submit_move_wrapper: function(item) {
      if (!item.to_locsub) {
        this.$vex.dialog.alert({
          message: "Please select a target location to move items to."
        });
        return;
      }

      if (item.locsub == item.to_locsub) {
        this.$vex.dialog.alert({
          message: "Cannot move inventory into the same location."
        });
        return;
      }

      item.move_quantity = parseInt(item.move_quantity);
      item.in_stock = parseInt(item.in_stock);

      if (isNaN(item.move_quantity)) {
        this.$vex.dialog.alert({
          message: "Please enter a valid quantity to move."
        });
        return;
      } else {
        if (item.move_quantity > item.in_stock) {
          this.$vex.dialog.alert({
            message: "You cannot move more than available items."
          });
          return;
        } else {
          this.submit_move(item);
        }
      }
    },
    
    submit_move: function(item) {
      let path = "/api/inventory/move_inventory/";
      let data = {
        product_id: item.product_id,
        product_sku: item.product_sku,
        from_locsub: item.locsub,
        to_locsub: item.to_locsub,
        move_quantity: item.move_quantity,
        username: this.packet.userDetails.username
      };
      let that = this;
      let s = function(response) {
        if (response.data.result) {
          that.$bvToast.toast("MOVE SUCCESSFUL!", {
            title: "Success",
            autoHideDelay: 1500,
            variant: "success"
          });
          that.get_out_of_stock_items();
        } else {
          that.$bvToast.toast("ERROR MOVING INVENTORY", {
            title: "Error",
            autoHideDelay: 1500,
            variant: "warning"
          });
          console.log(response.data.error);
        }
        that.items_being_loaded = false;
      };

      let f = function(error) {
        that.$bvToast.toast("Error moving inventory between locations.", {
          title: "Error",
          autoHideDelay: 1500,
          variant: "danger"
        });
        that.items_being_loaded = false;
      };

      this.items_being_loaded = true;
      Requestor.postSyncP(path, data, this, s, f);
    },
    
    cancel_move: function(item) {
      item.move_items = false;
    },
    
    move_items: function(item) {
      item.move_items = true;
    },

    get_out_of_stock_items: function() {
      let path = "/api/sales/get_out_of_stock_items/";
      let that = this;
      
      let data = {};
      if (that.start_date && that.end_date) {
        data.start_date = that.start_date;
        data.end_date = that.end_date;
      }
      
      let s = function(response) {
        if (response.data.result) {
          that.items = response.data.result.map(item => ({
            ...item,
            original_locsub: item.locsub,
            locsub: ""
          }));
          that.touchedItems.clear();
        } else {
          that.$bvToast.toast(response.data.error, {
            title: "Error",
            autoHideDelay: 1500,
            variant: "warning"
          });
        }
        that.items_being_loaded = false;
      };

      let f = function(error) {
        that.$bvToast.toast("Error retrieving out of stock items.", {
          title: "Error",
          autoHideDelay: 1500,
          variant: "danger"
        });
        that.items_being_loaded = false;
      };

      this.items_being_loaded = true;
      this.items = [];
      this.picked_locsub = null;
      Requestor.getSync(path, data, s, f);
    },
    
    sortby: function(key) {
      if (this.sort_asc) {
        this.items = Requestor.sort(this.items, key);
      } else {
        this.items = Requestor.sort_reverse(this.items, key);
      }
      this.sort_asc = !this.sort_asc;
    },
    
    total: function(key, qty) {
      let that = this;
      let out = 0.0;
      if (qty) {
        out = this.items
          .filter(function(d) {
            return that.allowed(d) == true;
          })
          .map(function(d) {
            return d[key] * d.in_stock;
          })
          .reduce((a, b) => a + b, 0);
      } else {
        out = this.items
          .filter(function(d) {
            return that.allowed(d) == true;
          })
          .map(function(d) {
            return d[key];
          })
          .reduce((a, b) => a + b, 0);
      }
      return out;
    },
    
    numberWithCommas: function(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    
    fetch_prereqs: function() {
      let that = this;
      let prereqs = [
        {
          path: "/api/inventory/get_all_loc_inventory_dict/",
          data: {},
          type: "",
          executable: Requestor.getAsync,
          s: function(response) {
            if (response.data.result) {
              that.all_loc_inventory_dict = response.data.result;
              that.allowed_locsubs = that.packet.locsubs.filter(d => d);
            } else {
              that.$bvToast.toast(response.data.error, {
                title: "Error",
                autoHideDelay: 1500,
                variant: "warning"
              });
            }
          },
          f: function(error) {
            console.log(error);
            that.$bvToast.toast("Error loading inventory.", {
              title: "Error",
              autoHideDelay: 1500,
              variant: "warning"
            });
          }
        }
      ];

      for (var i = 0; i < prereqs.length; i++) {
        let path = prereqs[i]["path"];
        let data = prereqs[i]["data"];
        let s = prereqs[i]["s"];
        let f = prereqs[i]["f"];
        let type = prereqs[i]["type"];
        if (type == "secure") {
          prereqs[i]["executable"](path, data, this, s, f);
        } else {
          prereqs[i]["executable"](path, data, s, f);
        }
      }
    },
    
    edit_in_stock: function(item) {
      item.edit_in_stock = true;
      return;
    },
    
    cancel_save_in_stock: function(item) {
      item.edit_in_stock = false;
      return;
    },
    
    save_in_stock: function(item) {
      let product_sku = item.product_sku;
      let splitted = item.locsub.split("|");
      let location_id = parseInt(splitted[0]);
      let sublocation_id = parseInt(splitted[1]);
      let nitems = parseInt(item.in_stock_fake);
      if (isNaN(nitems)) {
        this.$vex.dialog.alert({
          message: "Please specify a valid quantity for the item"
        });
        return;
      }
      if (isNaN(location_id) || isNaN(sublocation_id)) {
        this.$vex.dialog.alert({
          message: "Invalid location for the item. Please refresh the page."
        });
        return;
      }
      if (!product_sku) {
        this.$vex.dialog.alert({
          message: "Invalid product. Please refresh the page."
        });
        return;
      }
      let data = {
        product_sku: product_sku,
        location_id: location_id,
        sublocation_id: sublocation_id,
        nitems: nitems
      };

      let path = "/api/inventory/update_inventory/";
      let that = this;
      let s = function(response) {
        if (response.data.error) {
          that.$bvToast.toast(response.data.error, {
            title: "Error",
            autoHideDelay: 1500,
            variant: "warning"
          });
        } else {
          that.$bvToast.toast("UPDATED PRODUCT INVENTORY.", {
            title: "Success",
            autoHideDelay: 1500,
            variant: "success"
          });
          item.edit_in_stock = false;
          item.in_stock = parseInt(item.in_stock_fake);
        }
      };

      let f = function(error) {
        that.$bvToast.toast(
          "Error updating inventory. Please try again later.",
          { title: "Error", autoHideDelay: 1500, variant: "danger" }
        );
        item.edit_in_stock = false;
      };
      Requestor.postAsyncP(path, data, this, s, f);
      return;
    },
    
    getProductDisplayLocsub: function(item) {
      return item.original_locsub || item.locsub;
    },
    
    getAvailableLocsubs: function(item) {
      if (!item || !this.all_loc_inventory_dict) return [];

      return this.packet.locsubs.filter(locsub => {
        if (!locsub) return false;

        if (item.locsub === locsub.value) {
          return true;
        }

        const inventoryKey = this.concater([
          item.product_sku,
          locsub.location_id,
          locsub.sublocation_id
        ]);
        const inventoryCount = this.all_loc_inventory_dict[inventoryKey] || 0;

        return inventoryCount > 0;
      });
    },
    
    isOutOfStock: function(item, locsub) {
      if (!item || !locsub || !this.all_loc_inventory_dict) return false;

      const inventoryKey = this.concater([
        item.product_sku,
        locsub.location_id,
        locsub.sublocation_id
      ]);
      const inventoryCount = this.all_loc_inventory_dict[inventoryKey] || 0;

      return inventoryCount <= 0;
    },
    
    concater: function(items) {
      let out = items.join("|");
      return out;
    }
  },
  
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  
  mounted: function() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    const Lightpick = require("lightpick");
    let that = this;

    var picker = new Lightpick({
      field: document.getElementById("dates"),
      singleDate: false,
      repick: true,
      onSelect: function(start, end) {
        that.start_date = start
          ? start.startOf("day").format("YYYY-MM-DD")
          : null;
        that.end_date = end ? end.endOf("day").format("YYYY-MM-DD") : null;
        
        if (start && end) {
          that.date_range = `${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`;
        } else {
          that.date_range = "";
        }
        
        that.get_out_of_stock_items();
      }
    });
  },
  
  created: function() {
    this.packet = JSON.parse(localStorage.packet);
    this.packet.userDetails = JSON.parse(localStorage.userDetails);
    let that = this;
    
    if (this.packet.userDetails.properties.location_id) {
      let location_id = this.packet.userDetails.properties.location_id;
      this.locations = this.packet.locations.filter(function(d) {
        return d.value == location_id || d.is_main_warehouse == true;
      });
    } else {
      this.locations = this.packet.locations;
    }

    this.locations = this.locations.filter(function(d) {
      return d.value == 46;
    });
    this.locations = this.locations.sort(function(a, b) {
      return a.is_main_warehouse - b.is_main_warehouse;
    });

    this.fetch_prereqs();
    this.get_out_of_stock_items();
  }
};
</script>

<style scoped>
.non-header {
  font-weight: normal;
  font-size: 12px;
}

.ipt_tdhr {
  font-weight: bold;
  font-size: 12px;
}

.ipt_tdr {
  font-weight: normal;
  font-size: 12px;
  background-color: aliceblue;
}

.invalid-location {
  border: 1px solid #dc3545 !important;
}

.required-field::after {
  content: " *";
  color: #dc3545;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/OutOfStockProducts.vue